import { render, staticRenderFns } from "./QuestionDailyPracticeList.vue?vue&type=template&id=1bd6936d&"
import script from "./QuestionDailyPracticeList.vue?vue&type=script&lang=js&"
export * from "./QuestionDailyPracticeList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDailyPracticeList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports